import FuseLoadable from '@fuse/components/FuseLoadable/FuseLoadable'

export const CalendarConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/calendar',
      component: FuseLoadable({
        loader: () => import('./Calendar')
      })
    }
  ]
}
